require('./stylesheet/index.scss');

angular.module('pages.yasno', [])
	.config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
	$stateProvider
		.state('pages.yasno', {
			url: 'yasno/:url',
			template: require('./templates/index.html'),
			controller: require('../payment/controllers/payment'),
			data: {
				iframe: true,
			},
			params: {
				fields: {},
				serviceId: null,
				autoCheck: null,
				subscribe: null,
				amount: null,
				counters: null,
				account: null,
				lastDate: null,
				destination: null,
				templateId: null,
				editForbid: false
			},
			pageTrack: '/yasno'
		})
}

module.exports = 'pages.yasno';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/yasno/index.js
 ** module id = 301
 ** module chunks = 1
 **/